module.exports = __webpack_public_path__ + "img/ywAward-3.06dbadf8.png";